import React from 'react';

const MESSAGES: Record<string, string> = {
  ORG_NOT_SUBSCRIBED:
    'Aucune organisation abonnée à InventWee n’est associée à ce compte.',
  ORG_NOT_CONFIGURED:
    'Cette organisation n’est pas encore activée dans InventWee.',
  NO_APP_PROFILE:
    'Aucun profil InventWee pour cette organisation. Contactez votre administrateur.',
  PILOT_RESTRICTED:
    'La connexion Assowee est réservée aux comptes pilote pour le moment.',
};

/** Refus après SSO (0 organisation éligible, ou profil applicatif absent). */
const SsoAccessDeniedPage: React.FC = () => {
  const code = new URLSearchParams(window.location.search).get('code') || 'ORG_NOT_SUBSCRIBED';
  const message = MESSAGES[code] || MESSAGES.ORG_NOT_SUBSCRIBED;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <p className="text-sm font-medium text-indigo-600 mb-2">Accès refusé</p>
        <h1 className="text-2xl font-bold text-gray-900 mb-4">InventWee</h1>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default SsoAccessDeniedPage;
